import { createSelector, createSlice } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

interface File {
  path: string;
  name: string;
  duration: number;
}

// API slice for fetching playlist
export const playlistApi = createApi({
  reducerPath: "playlistApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://0xfm.com/api/open", // URL completa de tu servidor externo
    // baseUrl: "http://localhost:3002/api/open", // URL completa de tu servidor externo
    // baseUrl: "https://0xfm.com/api/open", // URL completa de tu servidor externo
    prepareHeaders: (headers) => {
      // Agregar headers si tu API los requiere
      headers.set("Content-Type", "application/json");
      // headers.set('Authorization', 'Bearer tu-token'); // Si necesitas auth
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPlaylist: builder.query<
      File[],
      { playlistId?: string; artist?: string; songId?: string }
    >({
      query: ({ playlistId, artist, songId }) => {
        if (songId) {
          return `song?id=${songId}`;
        } else {
          // Si no hay playlistId, usar endpoint por defecto
          if (!playlistId) {
            if (artist) {
              return `playlist?artist=${artist}`;
            } else {
              return "playlist";
            }
          }
        }

        // Si hay playlistId, pasarlo como parámetro
        return `playlist?id=${playlistId}`;
        // O como path param: return `playlist/${playlistId}`;
      },
    }),
  }),
});

export const { useGetPlaylistQuery } = playlistApi;

// const SONGS_DOMAIN = "https://0x6368656174.github.io/react-winamp";
const SONGS_DOMAIN = "";
// const SONGS_DOMAIN = "https://myclonejackson.com";

// Fallback playlist en caso de que falle la API
const fallbackPlaylist: File[] = [
  {
    name: "loading...",
    path: SONGS_DOMAIN + "/songs/yodel-edm.mp3",
    duration: 4 * 60 + 20,
    // duration: 3 * 60 + 20,
  },
  // {
  //   name: "Yodel + Musical / Orchestral",
  //   path: SONGS_DOMAIN + "/songs/yodel-musical.mp3",
  //   duration: 2 * 60 + 5,
  // },
  // {
  //   name: "Yodel + Trap",
  //   path: SONGS_DOMAIN + "/songs/yodel-trap.mp3",
  //   duration: 2 * 60 + 14,
  // },
  // {
  //   name: "Yodel + Swing / Big Band",
  //   path: SONGS_DOMAIN + "/songs/yodel-big-band.mp3",
  //   duration: 2 * 60 + 14,
  // },
  // {
  //   name: "Yodel + Blues (1)",
  //   path: SONGS_DOMAIN + "/songs/yodel-blues.mp3",
  //   duration: 2 * 60 + 48,
  // },
  // {
  //   name: "Yodel + Blues (2)",
  //   path: SONGS_DOMAIN + "/songs/yodel-blues-2.mp3",
  //   duration: 3 * 60 + 17,
  // },
  // {
  //   name: "Yodel + Indian",
  //   path: SONGS_DOMAIN + "/songs/yodel-indian.mp3",
  //   duration: 3 * 60 + 4,
  // },
  // {
  //   name: "Yodel + Reggae 🇯🇲",
  //   path: SONGS_DOMAIN + "/songs/yodel-reggae.mp3",
  //   duration: 2 * 60 + 54,
  // },
  // ! DEFAULT SHIT:::::
  // {
  //   name: "Jay Z - 99 Problems",
  //   path: SONGS_DOMAIN + "/songs/jay-z_99-problems.mp3",
  //   duration: 234,
  // },
  // {
  //   name: "Eminem & Dido — Stan",
  //   path: SONGS_DOMAIN + "/songs/eminem_stan.mp3",
  //   duration: 404,
  // },
  // {
  //   name: "50 Cent - In Da Club",
  //   path: SONGS_DOMAIN + "/songs/50-cent_in-da-club.mp3",
  //   duration: 193,
  // },
  // {
  //   name: "Radiohead - Everything In Its Right Place",
  //   path: SONGS_DOMAIN + "/songs/radiohead_everything-in-its-right-place.mp3",
  //   duration: 251,
  // },
  // {
  //   name: "Kanye West - Gold Digger",
  //   path: SONGS_DOMAIN + "/songs/kanye-west_gold-digger.mp3",
  //   duration: 207,
  // },
  // {
  //   name: "Franz Ferdinand - Take Me Out",
  //   path: SONGS_DOMAIN + "/songs/franz-ferdinand_take-me-out.mp3",
  //   duration: 237,
  // },
  // {
  //   name: "U2 — Moment Of Surrender",
  //   path: SONGS_DOMAIN + "/songs/u2_moment-of-surrender.mp3",
  //   duration: 444,
  // },
  // {
  //   name: "Gorillaz - Clint Eastwood",
  //   path: SONGS_DOMAIN + "/songs/gorillaz_clint-eastwood.mp3",
  //   duration: 339,
  // },
  // {
  //   name: "Britney Spears - Toxic",
  //   path: SONGS_DOMAIN + "/songs/britney-spears_toxic.mp3",
  //   duration: 245,
  // },
  // {
  //   name: "Green Day - American Idiot",
  //   path: SONGS_DOMAIN + "/songs/green-day_american-idiot.mp3",
  //   duration: 174,
  // },
  // {
  //   name: "Lady Gaga - Poker Face",
  //   path: SONGS_DOMAIN + "/songs/lady-gaga_poker-face.mp3",
  //   duration: 207,
  // },
  // {
  //   name: "P!nk - Get The Party Started",
  //   path: SONGS_DOMAIN + "/songs/pink_get-the-party-started.mp3",
  //   duration: 191,
  // },
  // {
  //   name: "Madonna - Hung Up",
  //   path: SONGS_DOMAIN + "/songs/madonna_hung-up.mp3",
  //   duration: 336,
  // },
];

interface State {
  state: "played" | "stopped" | "paused";
  showTimeLeft: boolean;
  duration: number;
  position: number;
  volume: number;
  balance: number;
  currentSongNumber: number;
  freq: number[];
  playlist: File[];
  shuffleEnabled: boolean;
  repeatEnabled: boolean;
  messageText: string;
  playlistVisible: boolean;
}

export const appSlice = createSlice({
  name: "app",
  initialState: {
    state: "stopped",
    showTimeLeft: false,
    duration: 0,
    position: 0,
    volume: 0.8,
    balance: 0,
    currentSongNumber: 0,
    freq: [],
    playlist: fallbackPlaylist,
    repeatEnabled: false,
    shuffleEnabled: false,
    messageText: "",
    playlistVisible: true,
  } as State,
  reducers: {
    setPlaylist: (state, action) => {
      state.playlist = action.payload;
      // Reset current song if the new playlist is shorter
      if (state.currentSongNumber >= action.payload.length) {
        state.currentSongNumber = 0;
        state.state = "stopped";
        state.position = 0;
      }
    },
    play: (state) => {
      if (state.state === "played") {
        state.position = 0;
      } else {
        state.state = "played";
      }
    },
    stop: (state) => {
      state.state = "stopped";
      state.position = 0;
      state.freq = [];
    },
    pause: (state) => {
      if (state.state === "paused") {
        state.state = "played";
      } else {
        state.state = "paused";
      }
    },
    durationChanged: (state, action) => {
      state.duration = action.payload;
    },
    positionChanged: (state, action) => {
      state.position = action.payload;
    },
    showTimeLeftToggled: (state) => {
      state.showTimeLeft = !state.showTimeLeft;
    },
    volumeChanged: (state, action) => {
      state.volume = action.payload;

      if (state.messageText.startsWith("VOLUME")) {
        state.messageText = `VOLUME: ${Math.floor(state.volume * 100)}%`;
      }
    },
    balanceChanged: (state, action) => {
      state.balance = action.payload;

      if (state.messageText.startsWith("BALANCE")) {
        const value = Math.floor(Math.floor(state.balance));
        let balanceText = "CENTER";
        if (value < 0) {
          balanceText = `${-1 * value}% LEFT`;
        } else if (value > 0) {
          balanceText = `${value}% RIGHT`;
        }
        state.messageText = `BALANCE: ${balanceText}`;
      }
    },
    freqChanged: (state, action) => {
      if (state.state !== "stopped") {
        state.freq = action.payload;
      } else {
        state.freq = [];
      }
    },
    nextSong: (state, action) => {
      const nextSongNumber = getNextSong(
        state.playlist,
        state.currentSongNumber,
        state.shuffleEnabled,
        state.repeatEnabled,
        action.payload
      );

      if (nextSongNumber === undefined) {
        state.state = "stopped";
      } else {
        state.currentSongNumber = nextSongNumber;
      }
    },
    currentSongChanged: (state, action) => {
      const newSongNumber = action.payload;

      // Check if the clicked song is the same as the one currently set
      // AND if the player is currently in a "played" state.
      if (
        state.currentSongNumber === newSongNumber &&
        state.state === "played"
      ) {
        // If yes, it's a double-click on the already playing song.
        // We want to restart it.
        state.position = 0; // Reset position to 0
        // state.state remains "played".
        // state.currentSongNumber remains the same.
      } else {
        // Different song, or the same song but player was paused/stopped,
        // or it's the first time a song is selected after app load.
        state.currentSongNumber = newSongNumber;
        state.state = "played";
        state.position = 0;
      }
      // state.currentSongNumber = action.payload;
      // state.state = "played";
      // state.position = 0;
    },
    shuffleEnabledChanged: (state, action) => {
      state.shuffleEnabled = action.payload;
    },
    repeatEnabledChanged: (state, action) => {
      state.repeatEnabled = action.payload;
    },
    messageTextChanged: (state, action) => {
      state.messageText = action.payload;
    },
    playlistVisibleChanged: (state, action) => {
      state.playlistVisible = action.payload;
    },
  },
});

export const {
  play,
  stop,
  pause,
  positionChanged,
  showTimeLeftToggled,
  volumeChanged,
  balanceChanged,
  durationChanged,
  freqChanged,
  nextSong,
  currentSongChanged,
  shuffleEnabledChanged,
  repeatEnabledChanged,
  messageTextChanged,
  playlistVisibleChanged,
  setPlaylist,
} = appSlice.actions;

export const selectApp = (state: { app: State }) => state.app;
export const selectState = createSelector([selectApp], (state) => state.state);
export const selectDuration = createSelector(
  [selectApp],
  (state) => state.duration
);
export const selectPosition = createSelector(
  [selectApp],
  (state) => state.position
);
export const selectVolume = createSelector(
  [selectApp],
  (state) => state.volume
);
export const selectBalance = createSelector(
  [selectApp],
  (state) => state.balance
);
export const selectShowTimeLeft = createSelector(
  [selectApp],
  (state) => state.showTimeLeft
);
export const selectCurrentSongNumber = createSelector(
  [selectApp],
  (state) => state.currentSongNumber
);
export const selectPlaylist = createSelector(
  [selectApp],
  (state) => state.playlist
);
export const selectCurrentSong = createSelector(
  [selectPlaylist, selectCurrentSongNumber],
  (playlist, currentSongNumber) => {
    return playlist[currentSongNumber];
  }
);
export const selectTotalDuration = createSelector(
  [selectPlaylist],
  (playlist) => playlist.reduce((acc, file) => acc + file.duration, 0)
);

export const selectFreq = createSelector([selectApp], (state) => state.freq);

export const selectShuffleEnabled = createSelector(
  [selectApp],
  (state) => state.shuffleEnabled
);
export const selectRepeatEnabled = createSelector(
  [selectApp],
  (state) => state.repeatEnabled
);

export const selectMessageText = createSelector(
  [selectApp],
  (state) => state.messageText
);
export const selectPlaylistVisible = createSelector(
  [selectApp],
  (state) => state.playlistVisible
);

function getNextSong(
  playlist: State["playlist"],
  currentSongNumber: number,
  shuffleEnabled: boolean,
  repeatEnabled: boolean,
  increment: 1 | -1
) {
  if (selectPlaylist.length === 1) {
    if (repeatEnabled) {
      return 0;
    } else {
      return undefined;
    }
  }

  if (shuffleEnabled) {
    let next = currentSongNumber;
    while (next === currentSongNumber) {
      next = Math.floor(Math.random() * playlist.length);
    }

    return next;
  }

  if (increment > 0 && currentSongNumber !== playlist.length - 1) {
    return currentSongNumber + increment;
  } else if (increment < 0 && currentSongNumber !== 0) {
    return currentSongNumber + increment;
  }

  if (repeatEnabled) {
    return increment > 0 ? 0 : playlist.length - 1;
  }

  return undefined;
}

export default appSlice.reducer;
